import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";

import Home from "./Pages/Home";
import GestaoContabil from "./Pages/Serviços/GestaoContabil";
import GestaoEmpresa from "./Pages/Serviços/GestaoEmpresa";
import GestaoTrabalhista from "./Pages/Serviços/GestaoTrabalhista";
import PlanejamentoTributario from "./Pages/Serviços/PlanejamentoTributario";
import ImpostoRenda from "./Pages/Serviços/ImpostoRenda";
import Complementares from "./Pages/Serviços/Complementares";
import Sobre from "./Pages/Sobre";
import Contato from "./Pages/Contato";
import Blog from "./Pages/Blog";
import ImpostoRendaBlog from "./Pages/BlogPaginas/id1impostoRenda";
import AbonoSalarialBlog from "./Pages/BlogPaginas/id2AbonoSalarial";
import InformativoTrabalhistaBlog from "./Pages/BlogPaginas/id3InformativoTrabalhista";
import FiscalizacaoTrabalhista from "./Pages/BlogPaginas/id4FicalizacaoTrabalhista";
import FimEscala from "./Pages/BlogPaginas/id5FimEscala6x1";
import MudancaMei from "./Pages/BlogPaginas/id6MudancaMei";
import TermosUso from "./Pages/TermosUso";
import PoliticaPrivacidade from "./Pages/PoliticaPrivacidade";
import PageTemplate from "./Pages/PageTemplate";
import PageNotFind from "./Pages/PageNotFound";
import ScrollToTop from "./scrollToTop";

const PageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'pageview',
            page_path: location.pathname,
            page_search: location.search
        });
    }, [location]);

    return null;
};

function AppRoutes() {
    return (
        <BrowserRouter>
            <PageTracker />
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<PageTemplate />}>
                    <Route index element={<Home />} />
                    <Route path="servico/gestao-contabil" element={<GestaoContabil />} />
                    <Route path="servico/gestao-de-empresas" element={<GestaoEmpresa />} />
                    <Route path="servico/gestao-trabalhista-rh" element={<GestaoTrabalhista />} />
                    <Route path="servico/planejamento-tributario" element={<PlanejamentoTributario />} />
                    <Route path="servico/imposto-de-renda" element={<ImpostoRenda />} />
                    <Route path="servico/servicos-complementares" element={<Complementares />} />
                    
                    <Route path="sobre" element={<Sobre />} />
                    <Route path="contato" element={<Contato />} />

                    <Route path="blog" element={<Blog />} />
                    <Route path="blog/1" element={<ImpostoRendaBlog />} />
                    <Route path="blog/2" element={<AbonoSalarialBlog />} />
                    <Route path="blog/3" element={<InformativoTrabalhistaBlog />} />
                    <Route path="blog/4" element={<FiscalizacaoTrabalhista />} />
                    <Route path="blog/5" element={<FimEscala />} />
                    <Route path="blog/6" element={<MudancaMei />} />
                    <Route path="termos" element={<TermosUso />} />
                    <Route path="privacidade" element={<PoliticaPrivacidade />} />

                    <Route path="*" element={<PageNotFind />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default AppRoutes;